type Nullable<T> = T | null | undefined

type EventLocation = {
  name?: Nullable<string>
  countryCode?: Nullable<string>
}

type LocationEvent = {
  location?: Nullable<EventLocation>
  events?: Nullable<
    {
      code?: Nullable<string>
      date?: Nullable<string>
      isEstimated?: Nullable<boolean>
      vesselNumber?: Nullable<string>
    }[]
  >
}

type TransitEvent = {
  isTransit: boolean
  departureLocation?: Nullable<EventLocation>
  departureDate?: Nullable<string>
  arrivalLocation?: Nullable<EventLocation>
  arrivalDate?: Nullable<string>
  isEstimated?: Nullable<boolean>
  vesselNumber?: Nullable<string>
}

export const isTransitEvent = (event: LocationEvent | TransitEvent): event is TransitEvent =>
  !!(event as TransitEvent).isTransit

export const first = <T>(ary?: T[]): T | undefined => ary?.[0]
export const last = <T>(ary?: T[]): T | undefined => (ary ? ary[ary.length - 1] : undefined)

export const injectTransitEventsToContainerEvents = (
  containerEvents: LocationEvent[]
): (LocationEvent | TransitEvent)[] =>
  containerEvents.reduce((result, currentContainerEvent, index, ary) => {
    const nextContainerEvent = ary[index + 1]
    if (nextContainerEvent) {
      return [
        ...result,
        {...currentContainerEvent},
        {
          isTransit: true,
          vesselNumber: last(currentContainerEvent?.events ?? [])?.vesselNumber,
          departureLocation: currentContainerEvent?.location,
          departureDate: last(currentContainerEvent?.events ?? [])?.date,
          arrivalLocation: nextContainerEvent?.location,
          arrivalDate: first(nextContainerEvent?.events ?? [])?.date,
          isEstimated: first(nextContainerEvent?.events ?? [])?.isEstimated,
        },
      ]
    }
    return [...result, currentContainerEvent]
  }, [] as (LocationEvent | TransitEvent)[])
